export const emailRegex =
  /^([a-zA-Z0-9_\-.+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,7}|[0-9]{1,7})(\]?)$/m;

export const macAddressRegex = /^(?:(?:[0-9A-Fa-f]{2}(?=([-:.]))(?:\1[0-9A-Fa-f]{2}){5}))$/m;
